import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../../generic.service';
import { PackagesRequest } from '../../../models/payment/packagesRequest';
import { PackagesResponse } from '../../../models/payment/packagesResponse';
import { CreatePackageRequest } from '../../../models/payment/createpackageRequests';
import { apiResponse } from '../../../models/apiResponse';

@Injectable({
  providedIn: 'root'
})
export class PackagesService {
  constructor(private genericService: GenericService) { }

  getAllPackages(request: PackagesRequest): Observable<PackagesResponse[]> {
    return this.genericService.post('package', request);
  }

  createPackage(data: CreatePackageRequest): Observable<PackagesResponse> {
    return this.genericService.post<PackagesResponse>('packages', data);
  }

  getPackageById(id: number): Observable<PackagesResponse> {
    return this.genericService.get<PackagesResponse>(`packages/${id}`);
  }

  updatePackage(id: number, data: CreatePackageRequest): Observable<PackagesResponse> {
    return this.genericService.put<PackagesResponse>(`packages/${id}`, data);
  }

  updatePackageStatus(id: number): Observable<any> {
    return this.genericService.put(`packages/status/${id}`, {});
  }

  searchPackageNames(searchText: string): Observable<string[]> {
    return this.genericService.get<string[]>(`packages/names/${searchText}`);
  }

  getPackageBySystemAssignedName(name: string): Observable<PackagesResponse> {
    const encodedName = encodeURIComponent(name);
    return this.genericService.get<PackagesResponse>(`packages/system-assigned-name/${encodedName}`);
  }

  getActivePackages(): Observable<apiResponse<PackagesResponse[]>> {
    return this.genericService.get('packages/active');
  }

  deletePackage(id: number): Observable<any> {
    return this.genericService.delete(`packages/${id}`);
  }
}
